import imageImg from "../../../../../picture/slika.png";
import wordImg from "../../../../../picture/word.png";
import pdfImg from "../../../../../picture/pdf.png";
import scanImg from "../../../../../picture/scan.png";
import uploadImg from "../../../../../picture/UploadDocument.png";
import downloadImg from "../../../../../picture/DownloadFile.png";
import visibleImg from "../../../../../picture/Visible.png";
import forwardImg from "../../../../../picture/forward.png";
import letterAImg from "../../../../../picture/letterA.png";
import { useRef, useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import ConfirmationModal from "../../../FolderDocument/ConfirmationModal";
import axios from "axios";

const styles = {
  cell: { padding: "5px", textAlign: "center" },
  smallCell: { width: "40px", textAlign: "center", cursor: "pointer" },
};

function RadnoMestoDokVazeca({
  dokumenta,
  moveToArhivirani,
  checkedRows,
  setCheckedRows,
  isCheckedAll,
  setIsCheckedAll,
  onRefresh,
}) {
  const [selectedField, setSelectedField] = useState({
    documentId: "",
    documentType: "",
  });
  const [isOpenEditConfirm, setIsOpenEditConfirm] = useState(false);
  const [fileNewDocument, setFileNewDocument] = useState(null);
  const [newExpiryDate, setNewExpiryDate] = useState("");
  const [pendingUploadId, setPendingUploadId] = useState(null);
  const [pendingUploadColumn, setPendingUploadColumn] = useState(null);

  const fileInputRef = useRef();
  const { dictionary, baseUrl } = useGlobalContext();

  const handleSelectDocument = (documentId, documentType) => {
    setSelectedField((prev) =>
      prev.documentId === documentId && prev.documentType === documentType
        ? { documentId: "", documentType: "" }
        : { documentId, documentType },
    );
  };

  const handleCheckRow = (id) => {
    setCheckedRows(
      checkedRows.includes(id)
        ? checkedRows.filter((r) => r !== id)
        : [...checkedRows, id],
    );
  };

  const handleCheckAll = () => {
    setCheckedRows(isCheckedAll ? [] : dokumenta.map((z) => z.id));
    setIsCheckedAll((prev) => !prev);
  };

  const handleClickUpload = (doc) => {
    if (!selectedField.documentId || selectedField.documentId !== doc.id) {
      alert("Prvo odaberi verziju (kockicu) ovog dokumenta.");
      return;
    }
    setPendingUploadId(doc.id);
    setPendingUploadColumn(selectedField.documentType);
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFileNewDocument(file);
    setIsOpenEditConfirm(true);
  };

  const handleConfirmEdit = async () => {
    try {
      const formData = new FormData();
      formData.append("file", fileNewDocument);
      formData.append("id", pendingUploadId);
      formData.append("column", pendingUploadColumn);
      if (newExpiryDate) formData.append("datum_isteka", newExpiryDate);

      const { data } = await axios.post(
        `${baseUrl}/workplaces/update_workplace_document_version.php`,
        formData,
      );
      if (data.status === 200) {
        onRefresh();
        setIsOpenEditConfirm(false);
        setFileNewDocument(null);
        setNewExpiryDate("");
        setPendingUploadId(null);
        setPendingUploadColumn(null);
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const handleDownload = (doc) => {
    if (!selectedField.documentId || selectedField.documentId !== doc.id) {
      alert("Prvo odaberi verziju (kockicu) ovog dokumenta.");
      return;
    }
    const pathKey = `${selectedField.documentType}_path`;
    const relativePath = doc[pathKey];
    if (!relativePath) {
      alert("Ova verzija dokumenta nema fajl.");
      return;
    }
    window.open(
      `${baseUrl}/zaposleni/download_document.php?path=${encodeURIComponent(relativePath)}`,
      "_blank",
    );
  };

  const handlePreview = (doc) => {
    if (!selectedField.documentId || selectedField.documentId !== doc.id) {
      alert("Prvo odaberi verziju (kockicu) ovog dokumenta.");
      return;
    }
    const pathKey = `${selectedField.documentType}_path`;
    const relativePath = doc[pathKey];
    if (!relativePath) {
      alert("Ova verzija dokumenta nema fajl.");
      return;
    }
    window.open(
      `${baseUrl.replace("/api", "")}/${relativePath}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handleShare = async (doc) => {
    if (!selectedField.documentId || selectedField.documentId !== doc.id) {
      alert("Prvo odaberi verziju (kockicu) ovog dokumenta.");
      return;
    }
    const pathKey = `${selectedField.documentType}_path`;
    const relativePath = doc[pathKey];
    if (!relativePath) {
      alert("Ova verzija dokumenta nema fajl.");
      return;
    }
    if (!navigator.canShare) {
      alert("Vaš browser ne podržava sistemsko deljenje.");
      return;
    }
    try {
      const fileUrl = `${baseUrl.replace("/api", "")}/${relativePath}`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const fileName = relativePath.split("/").pop().replace(/^\d+_/, "");
      const file = new File([blob], fileName, { type: blob.type });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: doc.naziv });
      }
    } catch (e) {
      console.error("Greška pri deljenju:", e);
    }
  };

  return (
    <>
      <table style={{ width: "100%", marginTop: "30px" }}>
        <thead>
          <tr>
            <th style={styles.smallCell}>
              <input
                type="checkbox"
                checked={isCheckedAll}
                onChange={handleCheckAll}
                style={{ width: "30px" }}
              />
            </th>
            <th style={styles.smallCell}>
              <img src={wordImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}>
              <img src={pdfImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}>
              <img src={imageImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}>
              <img src={scanImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.cell}>{dictionary["vazecaDokumenta"]}</th>
            <th style={styles.cell}>{dictionary["dodato"]}</th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
          </tr>
        </thead>
        <tbody>
          {dokumenta.map((dokument) => (
            <tr key={dokument.id}>
              <td style={styles.cell}>
                <input
                  type="checkbox"
                  checked={checkedRows.includes(dokument.id)}
                  onChange={() => handleCheckRow(dokument.id)}
                  style={{ width: "30px" }}
                />
              </td>
              {["word", "pdf", "image", "scan"].map((type) => (
                <td
                  key={type}
                  onClick={() => handleSelectDocument(dokument.id, type)}
                  style={{
                    ...styles.smallCell,
                    border:
                      selectedField.documentId === dokument.id &&
                      selectedField.documentType === type
                        ? "2px solid black"
                        : "",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: dokument[type],
                      width: "25px",
                      height: "25px",
                      margin: "auto",
                    }}
                  />
                </td>
              ))}
              <td style={styles.cell}>{dokument.naziv}</td>
              <td style={styles.cell}>{dokument.datum}</td>
              <td
                style={styles.smallCell}
                onClick={() => handlePreview(dokument)}
              >
                <img src={visibleImg} style={{ width: "30px" }} />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => handleShare(dokument)}
              >
                <img src={forwardImg} style={{ width: "30px" }} />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => handleDownload(dokument)}
              >
                <img src={downloadImg} style={{ width: "25px" }} />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => handleClickUpload(dokument)}
              >
                <img src={uploadImg} style={{ width: "25px" }} />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => moveToArhivirani(dokument)}
              >
                <img src={letterAImg} style={{ width: "20px" }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <input
        type="file"
        accept="image/*, .pdf, .docx"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileInputChange}
      />

      {isOpenEditConfirm && (
        <ConfirmationModal
          text="Potvrdite slanje i datum isteka:"
          handleConfirm={handleConfirmEdit}
          handleCancel={() => {
            setIsOpenEditConfirm(false);
            setFileNewDocument(null);
            setNewExpiryDate("");
          }}
        >
          <input
            type="date"
            value={newExpiryDate}
            onChange={(e) => setNewExpiryDate(e.target.value)}
            style={{ width: "100%", padding: "10px", marginTop: "10px" }}
          />
        </ConfirmationModal>
      )}
    </>
  );
}

export default RadnoMestoDokVazeca;
